export default __webpack_public_path__ + "static/uploadproductcsv-snapshot-1ecacbcc4d7b1301bc62e6ab1a925a2c.jpg";